import { snapshotRow } from "./timelineRows";

const STATUSES = new Set(["running", "succeeded", "failed", "superseded"]);

function validActivity(row) {
  return Boolean(
    row &&
    typeof row === "object" &&
    typeof row.id === "string" &&
    typeof row.label === "string" &&
    STATUSES.has(row.status),
  );
}

export function toPersistedTimelineActivity(value) {
  if (!Array.isArray(value)) return [];
  return value.filter(validActivity).map(snapshotRow);
}
